import React, { useState } from "react";
import Card from "../components/ui/Card/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import he from 'he';

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import ExchangeForm from "../components/ExchangeForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUserPlus,
    faShareNodes,
    faLocationDot,
    faPhone,
    faGlobe,
    faXmarkCircle,
    faEnvelope,
    faLanguage,
    faUserClock,
    faCopy,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
    faWhatsapp,
    faSnapchat,
    faInstagram,
    faLinkedin,
    faYoutube,
    faVimeo,
    faTumblr,
    faTiktok,
    faReddit,
    faPinterest,
    faBehance,
    faXTwitter,
    faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import CardFooter from "../components/CardFooter";
import EmbedVideo from "../components/EmbedVideo";
import PaymentsList from "../components/PaymentsList";
import BookAppointment from "../components/BookAppointment";
import Products from "../components/Products";
import FeaturedLinks from "../components/FeaturedLinks";
import Addresses from "../components/Addresses";
import About from "../components/About";
import { downloadVCard } from "../lib/vcard";
import {
    getSocialMedia,
    hasSocialLinks,
    getPhoneEntries,
    getFeaturedWebsiteLinks,
    getMomoNumber,
    formatWhatsAppUrl,
    ensureUrl,
} from "../lib/profileData";

// Import icons from React Icons
import { FaGlobe, FaFacebook, FaWhatsapp, FaTwitter, FaSnapchat, FaInstagram, FaLinkedin, FaYoutube, FaVimeo, FaTumblr, FaTiktok, FaReddit, FaPinterest } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

import bgDefaultImage from '../images/bg_default.jpeg';

const CardInfo = ({ profileData, profileImageUrl = '', coverImageUrl = '', logoUrl = '', cardUrl = '' }) => {

    const [saveToggled, setSaveToggled] = useState(false);
    const [emailToggled, setEmailToggled] = useState(false);
    const [shareToggled, setShareToggled] = useState(false);
    const [displayMails, setDisplayMails] = useState(false);
    const [webToggled, setWebToggled] = useState(false);
    const [displayImage, setDisplayImage] = useState(false);

    const toggleSave = () => setSaveToggled((prevState) => !prevState);
    const toggleEmail = () => setEmailToggled((prevState) => !prevState);
    const toggleShare = () => setShareToggled((prevState) => !prevState);
    const toggleMails = () => setDisplayMails((prevState) => !prevState);
    const toggleWeb = () => setWebToggled((prevState) => !prevState);
    const toggleDisplayImage = () => setDisplayImage((prevState) => !prevState);

    const handleDismissExchangeForm = () => {
        setSaveToggled(false);
    };
    const handleSaveContact = () => {
        downloadVCard(profileData, cardUrl);
    };

    const phoneEntries = profileData ? getPhoneEntries(profileData) : [];
    const primaryPhone = phoneEntries[0]?.number || profileData?.personalInfo?.user_phone;

    // Manually decode HTML entities
    const manualDecode = (str) => {
        // Replace `&amp;` with `&`
        const tempStr = str.replace(/&amp;/g, '&');
        return he.decode(tempStr);
    };

    const socialMedia = profileData ? getSocialMedia(profileData) : {};
    const hasSocialMedia = hasSocialLinks(socialMedia);
    const featuredProducts = profileData?.data?.featured_products || [];
    const featuredWebsiteLinks = profileData ? getFeaturedWebsiteLinks(profileData) : [];

    return (
        <main className="max-w-2xl mx-auto">
            {profileData ? (
                <>
                    <div
                        className={`h-full w-full z-20 left-0 bg-black px-5 bg-opacity-50 ${displayImage ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="top-5 left-5 z-10 absolute cursor-pointer text-white"
                                size="2x"
                                onClick={toggleDisplayImage}
                            />
                            <img
                                src="../images/profile.jpg"
                                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                        </div>
                    </div>

                    <div
                        className={`h-full w-full z-20 left-0 bg-black bg-opacity-50 ${saveToggled ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <div className=" top-5 left-5 absolute flex items-center bg-gray-200 p-2 rounded-full">
                                <FontAwesomeIcon
                                    icon={faXmarkCircle}
                                    className=" cursor-pointer text-red-500 "
                                    size="2x"
                                    onClick={toggleSave}
                                />
                                <div onClick={toggleSave} className=" cursor-pointer ml-2  text-black  bg-white rounded-full px-3 py-1">
                                    <p className="mb-0">Close</p>
                                </div>
                            </div>

                            <ExchangeForm
                                fetchUserId={`${profileData.cardInfo.user_id}`}
                                fetchCardId={`${profileData.cardInfo.id}`}
                                onDismiss={handleDismissExchangeForm}
                            />
                        </div>
                    </div>
                    <div
                        className={`h-full w-full z-20 left-0 bg-black bg-opacity-50 ${emailToggled ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="top-5 left-5 absolute cursor-pointer text-white"
                                size="2x"
                                onClick={toggleEmail}
                            />

                            <div className="w-full bg-white space-y-3 absolute bottom-0 rounded-t-xl py-2 px-2">
                                <img
                                    src="../images/eazylinkBlack.png"
                                    alt="Eazy Link "
                                    className="w-1/3 sm:w-1/5 mx-auto"
                                />

                                <div className="flex flex-col gap-3 px-2">
                                    {phoneEntries.map((entry) => (
                                        <a
                                            key={entry.id}
                                            href={`tel:${entry.number}`}
                                            className="flex gap-2 items-end border-b-2 border-neutral-400 pb-2"
                                        >
                                            <span className="h-10 text-blue-600 text-center w-12 sm:w-16 text-xs sm:text-sm">
                                                {entry.label}
                                            </span>
                                            <span className="flex-1 sm:text-lg">
                                                {entry.number}
                                            </span>
                                            <FontAwesomeIcon icon={faPhone} className="h-6 sm:h-8" />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`h-full w-full z-20 left-0 bg-black bg-opacity-50 ${displayMails ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="top-5 left-5 absolute cursor-pointer text-white"
                                size="2x"
                                onClick={toggleMails}
                            />

                            <div className="w-full bg-white space-y-3 absolute bottom-0 rounded-t-xl py-2 px-2">
                                <img
                                    src="../images/eazylinkBlack.png"
                                    alt="Eazy Link"
                                    className="w-1/3 sm:w-1/5 mx-auto"
                                />

                                <div className="flex flex-col gap-3 px-2">
                                    <a
                                        href={`mailto:${profileData.personalInfo.email}`}
                                        className="flex gap-2 items-end border-b-2 border-neutral-400 pb-2"
                                    >
                                        <span className="h-10 text-blue-600 text-center w-12 sm:w-16 text-xs sm:text-sm">
                                            Email 1
                                        </span>
                                        <span className="flex-1 sm:text-lg">
                                            {profileData.personalInfo.email}
                                        </span>
                                        <FontAwesomeIcon icon={faEnvelope} className="h-6 sm:h-8" />
                                    </a>
                                    {profileData.personalInfo.alt_email != "" ? (
                                        <a
                                            href={`mailto:${profileData.personalInfo.alt_email}`}
                                            className="flex gap-2 items-end border-b-2 border-neutral-400 pb-2"
                                        >
                                            <span className="h-10 text-blue-600 text-center w-12 sm:w-16 text-xs sm:text-sm">
                                                Email 2
                                            </span>
                                            <span className="flex-1 sm:text-lg">
                                                {profileData.personalInfo.alt_email}
                                            </span>
                                            <FontAwesomeIcon icon={faEnvelope} className="h-6 sm:h-8" />
                                        </a>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={`h-full w-full z-20 left-0 bg-black bg-opacity-50 ${webToggled ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="top-5 left-5 absolute cursor-pointer text-white"
                                size="2x"
                                onClick={toggleWeb}
                            />

                            <div className="w-full bg-white space-y-3 absolute bottom-0 rounded-t-xl py-2 px-2">
                                <img
                                    src="../images/eazylinkBlack.png"
                                    alt="Eazy Link "
                                    className="w-1/3 sm:w-1/5 mx-auto"
                                />

                                <div className="flex flex-col gap-3 px-2">
                                    {socialMedia && (socialMedia.website || socialMedia.website2) && (
                                        <>
                                            {socialMedia.website && (
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={ensureUrl(socialMedia.website)}
                                                    className="flex gap-2 items-end border-b-2 border-neutral-400 pb-2"
                                                >
                                                    <span className="h-10 text-blue-600 text-center w-12 sm:w-16 text-xs sm:text-sm">
                                                        Web 1
                                                    </span>
                                                    <span className="flex-1 sm:text-lg">
                                                        {socialMedia.website}
                                                    </span>
                                                    <FontAwesomeIcon icon={faGlobe} className="h-6 sm:h-8" />
                                                </a>
                                            )}
                                            {socialMedia.website2 && (
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={ensureUrl(socialMedia.website2)}
                                                    className="flex gap-2 items-end border-b-2 border-neutral-400 pb-2"
                                                >
                                                    <span className="h-10 text-blue-600 text-center w-12 sm:w-16 text-xs sm:text-sm">
                                                        Web 2
                                                    </span>
                                                    <span className="flex-1 sm:text-lg">
                                                        {socialMedia.website2}
                                                    </span>
                                                    <FontAwesomeIcon icon={faGlobe} className="h-6 sm:h-8" />
                                                </a>
                                            )}
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div
                        className={`h-full w-full z-20 left-0 bg-black bg-opacity-50 ${shareToggled ? "fixed" : "hidden"
                            }`}
                    >
                        <div className="max-w-2xl h-full relative mx-auto">
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="top-5 left-5 absolute cursor-pointer text-white"
                                size="2x"
                                onClick={toggleShare}
                            />

                            <div className="w-full bg-white space-y-3 text-black absolute bottom-0 rounded-t-xl py-2 px-2">
                                <p className="font-bold text-center">
                                    Scan QR code for my contact
                                </p>
                                <div className="flex flex-col gap-10 items-center">
                                    {profileData.data?.offline_qr && (
                                        <img
                                            src={profileData.data.offline_qr}
                                            alt="Contact QR code"
                                            className="h-32 w-32"
                                        />
                                    )}
                                    {/* <img
                                        src={profileData.data.offline_qr}
                                        className="h-32 w-32"
                                    /> */}
                                    {/* <span className="h-32 w-32 bg-red-500"></span>
                            <span className="h-32 w-32 bg-red-500"></span> */}
                                </div>
                                <div className="flex justify-center gap-5">
                                    {primaryPhone && (
                                    <a
                                        href={`tel:${primaryPhone}`}
                                        className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                    >
                                        <FontAwesomeIcon
                                            className="w-full h-full text-black"
                                            icon={faPhone}
                                        />
                                    </a>
                                    )}
                                    {socialMedia?.website ? (
                                        <a
                                            href={ensureUrl(socialMedia.website)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                        >
                                            <FontAwesomeIcon className="w-full h-full text-black" icon={faGlobe} />
                                        </a>
                                    ) : null}
                                    {
                                        // profileData.data?.socialmedia?.?.website ? (
                                        //     <a
                                        //         href={profileData.data.socialmedia.website}
                                        //         className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                        //     >
                                        //         <FontAwesomeIcon className="w-full h-full text-black" icon={faGlobe} />
                                        //     </a>
                                        // ) : null
                                    }
                                    {
                                        profileData?.personalInfo?.email ? (
                                            <a
                                                href={`mailto:${profileData.personalInfo.email}`}
                                                className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                            >
                                                <FontAwesomeIcon className="w-full h-full text-black" icon={faEnvelope} />
                                            </a>
                                        ) : null
                                    }
                                    {/* {
                                profileData.data?.socialmedia?.?.whatsapp ? (
                                    <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`https://${profileData.data.socialmedia.whatsapp}`}
                                    className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                    >
                                    <FontAwesomeIcon className="w-full h-full text-black" icon={faWhatsapp} />
                                    </a>
                                ) : null
                                }
                                {
                                profileData.data?.socialmedia?.?.linkedin ? (
                                    <a
                                    href={profileData.data.socialmedia.linkedin}
                                    className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b]"
                                    >
                                    <FontAwesomeIcon className="w-full h-full text-black" icon={faLinkedin} />
                                    </a>
                                ) : null
                                } */}

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Begining of the card */}
                    <div className="max-w-2xl absolute flex justify-between w-full px-5 z-10">
                        {/* <span className="w-10 h-10 text-white text-2xl mt-3 cursor-pointer">
                        <FontAwesomeIcon
                        icon={faLanguage}
                        className="w-full h-full object-cover"
                        />
                    </span>
                    <span className="w-10 h-10 text-white text-2xl mt-3 cursor-pointer">
                        <FontAwesomeIcon icon={faUserClock} />
                    </span> */}
                    </div>
                    <div className="h-40 relative rounded-b-3xl">

                        {/* {!profileData.cardInfo.cover_image_url ? (
                            <img
                                draggable="false"
                                src={`https://dashboard.eazylink.co/uploads/${profileData.cardInfo.cover_image_url}`}
                                alt="bg"
                                className="h-full w-full object-cover rounded-b-3xl"
                            />  
                        ) : ( */}
                            {coverImageUrl ? (
                                <img
                                    draggable="false"
                                    src={coverImageUrl}
                                    alt="bg"
                                    className="h-full w-full object-cover rounded-b-3xl"
                                />
                            ) : (
                                <img
                                    draggable="false"
                                    src={bgDefaultImage}
                                    alt=""
                                    className="h-full w-full object-cover rounded-b-3xl"
                                />
                            )}
                        {/* )} */}

                        {/* {profileData.data.business.profile_image ? (
                            <img
                                draggable="false"
                                className="h-36 w-36 -bottom-1/2 absolute left-1/2 -translate-x-1/2 border-8 border-my-blue border-opacity-70 rounded-full object-cover object-top"
                                src={`https://dashboard.eazylink.co/uploads/${profileData.data.business.profile_image}`}
                                alt="Profile"
                            />
                        ) : ( */}
                        {profileImageUrl ? (
                            <img
                                draggable="false"
                                className="h-36 w-36 -bottom-1/2 absolute left-1/2 -translate-x-1/2 border-8 border-my-blue border-opacity-70 rounded-full object-cover object-top"
                                src={profileImageUrl}
                                alt="Profile"
                            />
                        ) : (
                            <div className="h-36 w-36 -bottom-1/2 absolute left-1/2 -translate-x-1/2 border-8 border-my-blue border-opacity-70 rounded-full bg-gray-200" />
                        )}
                        {/* )} */}
                    </div>
                    <div className="mt-24 text-black">
                        <p className="text-center font-black text-black text-xl">
                            {profileData.cardInfo.card_name}
                        </p>
                        <p className="text-center flex flex-col items-center mt-1">
                            <span>{manualDecode(profileData.cardInfo.occupation)}</span>
                            <span>{manualDecode(profileData.personalInfo.company)}</span>
                        </p>
                    </div>

                    <div className="flex items-center gap-3 sm:gap-4 px-4 sm:px-12 justify-between mt-5">
                        <Card
                            custom="rounded-md text-sm justify-center gap-3 flex items-center flex-1"
                            clickHandler={handleSaveContact}
                        >
                            <span className="inset-0"></span>
                            <span>Save Contact</span>
                            <span className="w-5 h-5">
                                <FontAwesomeIcon icon={faUserPlus} className="w-full h-full" />
                            </span>
                        </Card>

                        <Card
                            custom="rounded-md text-sm justify-center gap-3 flex items-center flex-1"
                            clickHandler={toggleSave}
                        >
                            <span>Exchange Contact</span>
                            <span className="w-5 h-5">
                                <FontAwesomeIcon icon={faShareNodes} className="w-full h-full" />
                            </span>
                        </Card>
                    </div>

                    {/* share contact card component */}
                    {/* <div className="flex items-center gap-4 px-4 sm:px-12 justify-between mt-5">
                        <Card
                            custom="rounded-md text-sm justify-center gap-3 py-2 flex items-center flex-1"
                            clickHandler={toggleShare}
                        >
                            <span>share</span>
                            <span className="w-5 h-5">
                                <FontAwesomeIcon icon={faShareNodes} className="w-full h-full" />
                            </span>

                        </Card>

                    </div> */}

                    {hasSocialMedia ? (
                        <>
                            <div className="text-black flex items-center relative justify-between px-5 mt-8 font-semibold text-lg">
                                <span>Social Media</span>
                                <p className="group px-2 border">
                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                    <span className="absolute text-sm group-hover:inline text-black bg-neutral-300 right-5 font-normal px-2 hidden py-0.5 -bottom-3/4 rounded-sm">
                                        Scroll left for more social links
                                    </span>
                                </p>
                            </div>
                            <div className="px-5 overflow-x-scroll socialIcons">
                                <div className="flex gap-5 min-w-max pb-5 items-center mt-2">
                                    {socialMedia.website && (
                                        <span
                                            onClick={toggleWeb}
                                            className="w-10 h-10 cursor-pointer sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaGlobe className="w-full h-full text-blue-500" />
                                        </span>
                                    )}
                                    {socialMedia.facebook && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={socialMedia.facebook}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaFacebook className="w-full h-full text-blue-600" />
                                        </a>
                                    )}
                                    {socialMedia.whatsapp && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={formatWhatsAppUrl(socialMedia.whatsapp)}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaWhatsapp className="w-full h-full text-green-500" />
                                        </a>
                                    )}
                                    {socialMedia.twitter && (
                                        <a
                                            href={socialMedia.twitter}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaXTwitter className="w-full h-full text-black" />
                                        </a>
                                    )}
                                    {socialMedia.snapchat && (
                                        <a
                                            href={socialMedia.snapchat}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaSnapchat className="w-full h-full text-yellow-400" />
                                        </a>
                                    )}
                                    {socialMedia.instagram && (
                                        <a
                                            href={socialMedia.instagram}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaInstagram className="w-full h-full text-pink-600" />
                                        </a>
                                    )}
                                    {socialMedia.linkedin && (
                                        <a
                                            href={socialMedia.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaLinkedin className="w-full h-full text-blue-700" />
                                        </a>
                                    )}
                                    {socialMedia.youtube && (
                                        <a
                                            href={socialMedia.youtube}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaYoutube className="w-full h-full text-red-600" />
                                        </a>
                                    )}
                                    {socialMedia.vimeo && (
                                        <a
                                            href={socialMedia.vimeo}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaVimeo className="w-full h-full text-blue-500" />
                                        </a>
                                    )}
                                    {socialMedia.tumblr && (
                                        <a
                                            href={socialMedia.tumblr}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaTumblr className="w-full h-full text-blue-800" />
                                        </a>
                                    )}
                                    {socialMedia.tiktok && (
                                        <a
                                            href={socialMedia.tiktok}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaTiktok className="w-full h-full text-black" />
                                        </a>
                                    )}
                                    {socialMedia.reddit && (
                                        <a
                                            href={socialMedia.reddit}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaReddit className="w-full h-full text-orange-600" />
                                        </a>
                                    )}
                                    {socialMedia.pinterest && (
                                        <a
                                            href={socialMedia.pinterest}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaPinterest className="w-full h-full text-red-700" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </>
                    ) : null}

                    {/* {profileData.data.socialmedia.length > 0 && countNonEmptyFields(profileData.data.socialmedia) ? (
                        <>
                            <div className="text-black flex items-center relative justify-between px-5 mt-8 font-semibold text-lg">
                                <span>Social Media</span>
                                <p className="group px-2 border">
                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                    <span className="absolute text-sm group-hover:inline text-black bg-neutral-300 right-5 font-normal px-2 hidden py-0.5 -bottom-3/4 rounded-sm">
                                        Scroll left for more social links
                                    </span>
                                </p>
                            </div>
                            <div className="px-5 overflow-x-scroll socialIcons">
                                <div className="flex gap-5 min-w-max pb-5 items-center mt-2">
                                    {profileData.data.socialmedia.website && (
                                        <span
                                            onClick={toggleWeb}
                                            className="w-10 h-10 cursor-pointer sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaGlobe className="w-full h-full text-blue-500" />
                                        </span>
                                    )}
                                    {profileData.data?.socialmedia?.?.facebook && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={profileData.data.socialmedia.facebook}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaFacebook className="w-full h-full text-blue-600" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.whatsapp && (
                                        <a
                                            target="_blank"
                                            href={`https://${profileData.data.socialmedia.whatsapp}`}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaWhatsapp className="w-full h-full text-green-500" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.twitter && (
                                        <a
                                            href={profileData.data.socialmedia.twitter}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaXTwitter className="w-full h-full text-black" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.snapchat && (
                                        <a
                                            href={profileData.data.socialmedia.snapchat}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaSnapchat className="w-full h-full text-yellow-400" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.instagram && (
                                        <a
                                            href={profileData.data.socialmedia.instagram}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaInstagram className="w-full h-full text-pink-600" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.linkedin && (
                                        <a
                                            href={profileData.data.socialmedia.linkedin}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaLinkedin className="w-full h-full text-blue-700" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.youtube && (
                                        <a
                                            href={profileData.data.socialmedia.youtube}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaYoutube className="w-full h-full text-red-600" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.vimeo && (
                                        <a
                                            href={profileData.data.socialmedia.vimeo}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaVimeo className="w-full h-full text-blue-500" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.tumblr && (
                                        <a
                                            href={profileData.data.socialmedia.tumblr}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaTumblr className="w-full h-full text-blue-800" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.tiktok && (
                                        <a
                                            href={profileData.data.socialmedia.tiktok}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaTiktok className="w-full h-full text-black" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.reddit && (
                                        <a
                                            href={profileData.data.socialmedia.reddit}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaReddit className="w-full h-full text-orange-600" />
                                        </a>
                                    )}
                                    {profileData.data.socialmedia.pinterest && (
                                        <a
                                            href={profileData.data.socialmedia.pinterest}
                                            className="w-10 h-10 sm:w-14 sm:h-14 p-2 bg-white shadow-md rounded-lg shadow-[#0000003b] flex items-center justify-center"
                                        >
                                            <FaPinterest className="w-full h-full text-red-700" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </>
                    ) : */}

                    {profileData.cardInfo.description && (
                        <About about={manualDecode(profileData.cardInfo.description)} />
                    )}
                    {profileData.personalInfo.location && (
                        <Addresses address={manualDecode(profileData.personalInfo.location)} />
                    )}
                    {featuredProducts.length > 0 ? (
                        <Products featuredProducts={featuredProducts} />
                    ) : (
                        <FeaturedLinks links={featuredWebsiteLinks} />
                    )}
                    {/* {profileData.data.featured_products && profileData.data.featured_products.length > 0 && (
                        <Products featuredProducts={profileData.data.featured_products} />
                    )} */}
                    {profileData.cardInfo.calendly_link && (
                        <BookAppointment
                            name={profileData.personalInfo.firstname}
                            email={profileData.personalInfo.email}
                            calendlyLink={profileData.cardInfo.calendly_link}
                        />
                    )}
                    <PaymentsList
                        momoNumber={getMomoNumber(profileData.cardInfo)}
                        flutterwaveUrl={profileData.cardInfo.flutterwave_url}
                        wiseUrl={profileData.cardInfo.wise_url}
                    />
                    {profileData.cardInfo.video_url && (
                        <EmbedVideo
                            videoUrl={profileData.cardInfo.video_url}
                            videoTitle={profileData.cardInfo.video_title}
                        />
                    )}
                    {/* {profileData.data.gallery && profileData.data.gallery.length > 0 && (
                        <PhotoGallery photos={profileData.data.gallery} />
                    )} */}
                    <CardFooter logoUrl={logoUrl} />
                </>
            ) : (
                <p>No Data available. Contact <a href="https://eazylink.co">Eazylink Support</a> </p>
            )}
        </main>
    )
}

export default CardInfo